export let Language;

(function (Language) {
  Language["EN"] = "en";
  Language["DA"] = "da";
})(Language || (Language = {}));